import React from "react";
import { Link, useLocation } from "react-router-dom";
import { Home, Search, Music, Mic2, ArrowRight } from "lucide-react";

const SUGGESTIONS = [
  { to: "/", label: "Home", icon: Home },
  { to: "/mixtapes", label: "Mixtapes", icon: Music },
  { to: "/singles", label: "Singles", icon: Mic2 },
  { to: "/videos", label: "Videos", icon: Music },
  { to: "/jobs", label: "Jobs", icon: Search },
  { to: "/culture-connect", label: "Culture Connect", icon: Search },
];

export default function NotFoundPage() {
  const loc = useLocation();
  return (
    <div className="min-h-[calc(100vh-200px)] flex items-center px-4 sm:px-6 py-16" data-testid="not-found-page">
      <div className="max-w-[1200px] mx-auto w-full grid lg:grid-cols-[1.2fr_1fr] gap-12 items-center">
        <div>
          <div className="font-mono-label text-[10px] text-[var(--accent)] mb-3" data-testid="not-found-pill">
            ERROR · 404 · OFF THE MAP
          </div>
          <h1 className="font-display text-[14vw] sm:text-[10vw] lg:text-[8vw] leading-[0.85] uppercase mb-6 -tracking-[0.02em]">
            <span className="block text-white">Track</span>
            <span className="block text-[var(--accent)]">Not Found</span>
          </h1>
          <p className="text-neutral-300 text-base sm:text-lg max-w-xl mb-2">
            That URL doesn&apos;t scratch. Maybe the link got remixed, the page got pulled, or you typed something hot off the dome.
          </p>
          <p className="font-mono-label text-[10px] text-neutral-500 mb-8 break-all" data-testid="not-found-path">
            ATTEMPTED · {loc.pathname}
          </p>
          <div className="flex flex-wrap gap-3">
            <Link to="/" className="btn-primary" data-testid="not-found-home-btn">
              <Home size={14} /> Back to Home
            </Link>
            <Link to="/mixtapes" className="btn-ghost" data-testid="not-found-browse-btn">
              <Music size={14} /> Browse Mixtapes
            </Link>
          </div>
        </div>

        <div className="card-brut border-[var(--accent)] bg-gradient-to-br from-[#1a0a05] to-black p-7" data-testid="not-found-suggestions">
          <div className="font-mono-label text-[10px] text-[var(--accent)] mb-4">TRY THESE INSTEAD</div>
          <div className="space-y-2">
            {SUGGESTIONS.map(({ to, label, icon: Icon }) => (
              <Link
                key={to}
                to={to}
                className="group flex items-center justify-between gap-3 px-4 py-3 border border-neutral-800 hover:border-[var(--accent)] hover:bg-[var(--accent)]/5 transition-colors"
                data-testid={`not-found-suggestion-${label.toLowerCase().replace(/\s+/g, "-")}`}
              >
                <div className="flex items-center gap-3">
                  <Icon size={14} className="text-neutral-400 group-hover:text-[var(--accent)] transition-colors" />
                  <span className="font-mono-label text-[11px] uppercase tracking-wide">{label}</span>
                </div>
                <ArrowRight size={14} className="text-neutral-500 group-hover:text-[var(--accent)] group-hover:translate-x-1 transition-all" />
              </Link>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
